import { createContext, useContext, useEffect, useRef, useState } from "react"
import { Auth } from "aws-amplify"
import config from "../config"
import UserContext from "./user"

const SocketContext = createContext()

export function SocketContextWrapper({ children }) {
  const { user } = useContext(UserContext)
  const socket = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const getSocket = async () => {
      try {
        const session = await Auth.currentSession()
        let socketUrl = `${config.webSocketURL}?token=${session.getIdToken().getJwtToken()}`
        socket.current = new WebSocket(socketUrl)
        socket.current.onopen = () => {
          console.log("Socket connected!")
          setOpen(true)
        }
        socket.current.onclose = () => {
          console.log("Socket closed!")
          setOpen(false)
        }
        socket.current.onmessage = (event) => {
          console.log("Message from server ", event.data)
        }
      } catch (err) {
        console.error(err)
      }
    }
    getSocket().catch(console.error)

    return () => {
      if (socket.current) {
        console.log("CLOSING!!")
        socket.current.close()
      }
    }
  }, [user])

  useEffect(() => {
    if (open) {
      socket.current.onmessage = (event) => {
        console.log("Message from server ", event.data)
      }
    }
  }, [open])

  const send = (action, payload) => {
    if (open) {
      socket.current.send(JSON.stringify({ action: action, payload: payload }))
    }
  }

  return (
    <SocketContext.Provider value={{ send }}>{children}</SocketContext.Provider>
  )
}

export function useSocketContext() {
  return useContext(SocketContext)
}
